var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"\n    tw-inline-block\n    tw-rounded\n    tw-items-center\n    tw-whitespace-nowrap\n    tw-px-1.5\n    tw-py-px\n    tw-text-xs\n    tw-font-semibold\n    tw-border\n    tw-border-solid\n    tw-border-rounded\n  ",class:[
    _vm.data.staticClass,
    _vm.data.class,
    ("tw-text-" + (_vm.props.color ? _vm.props.color : 'gray-800') + " tw-border-" + (_vm.props.color ? _vm.props.color : 'gray-800')) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }